import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createActionsHook, createHook, createStore } from 'react-sweet-state';
import { addAppsErrors, resetAppErrors, setAppErrors } from './actions/app-errors';
import { detectAppliedChangesConflicts } from './actions/applied-changes-history';
import { collectFieldsAppliedChangesHistory, collectScreenTabsAppliedChangesHistory } from './actions/applied-changes-history/collect-history';
import { resetError, setError } from './actions/errors';
import { startFieldsInitialisationTimeout, successFieldsInitalisation } from './actions/fields-initialisation-timeout';
import { initializeField, initializeFields } from './actions/initialize-field';
import { initializeNoScreenTab } from './actions/initialize-no-screen-tab';
import { initializeScreenTabs } from './actions/initialize-screen-tabs';
import { resetNotification, setNotification } from './actions/notification';
import { processChange, processChangeNew, processChangeOld } from './actions/process-change';
import { registerFields, unregisterFields } from './actions/register-fields';
import { setFieldValue } from './actions/set-field-value';
import { updateActiveScreenTab } from './actions/update-active-screen-tab';
import { updateFields } from './actions/update-fields';
import { updateScreenTabs } from './actions/update-screen-tabs';
var name = 'issue-adjustments';
export var initialState = {
  formData: null,
  screenTabs: null,
  appliedChanges: null,
  error: null,
  registeredFieldsDeprecated: {},
  registeredFields: {},
  triggerFieldInitializationKey: 0,
  // Selector checks if this is not equal 0 in the useFieldReady
  numberOfSupportedFields: 0,
  internalFormMetadata: {},
  viewType: null,
  experienceDataIsLoading: false,
  lastProcessedChange: null,
  fieldsInitialization: {
    startTime: null,
    timeoutId: undefined,
    status: 'notStarted'
  },
  appliedChangesHistory: {},
  appsErrors: {},
  notification: null
};

// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
var triggerFieldInitializationKey = initialState.triggerFieldInitializationKey,
  scopedViewType = initialState.viewType,
  numberOfSupportedFields = initialState.numberOfSupportedFields,
  stateForResetAllFields = _objectWithoutProperties(initialState, ["triggerFieldInitializationKey", "viewType", "numberOfSupportedFields"]);
export var actions = {
  triggerFieldInitialization: function triggerFieldInitialization() {
    return function (_ref) {
      var getState = _ref.getState,
        setState = _ref.setState;
      setState({
        triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
      });
    };
  },
  processChange: processChange,
  // Remove on 'process-change-gets-field-type-from-store' FG cleanup. Added here for testing purposes only.
  processChangeNew: processChangeNew,
  processChangeOld: processChangeOld,
  // end of removal
  setFieldValue: setFieldValue,
  initializeField: initializeField,
  initializeFields: initializeFields,
  startFieldsInitialisationTimeout: startFieldsInitialisationTimeout,
  successFieldsInitalisation: successFieldsInitalisation,
  registerFields: registerFields,
  unregisterFields: unregisterFields,
  updateFields: updateFields,
  clearAppliedValue: function clearAppliedValue(fieldId) {
    return function (_ref2) {
      var setState = _ref2.setState,
        getState = _ref2.getState;
      var previousState = getState().appliedChanges || {};
      if (previousState[fieldId]) {
        var _previousState$fieldI = previousState[fieldId],
          value = _previousState$fieldI.value,
          otherFieldChanges = _objectWithoutProperties(_previousState$fieldI, _excluded);
        setState({
          appliedChanges: _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, fieldId, otherFieldChanges))
        });
      }
    };
  },
  resetAllFields: function resetAllFields() {
    return function (_ref3) {
      var setState = _ref3.setState,
        getState = _ref3.getState;
      // Clear the fieldsInitialization timeout to avoid potetianl side effects.
      clearTimeout(getState().fieldsInitialization.timeoutId);
      setState(stateForResetAllFields);
    };
  },
  setError: setError,
  resetError: resetError,
  setNumberOfSupportedFields: function setNumberOfSupportedFields(numberOfAllSupportedFields) {
    return function (_ref4) {
      var setState = _ref4.setState;
      setState({
        numberOfSupportedFields: numberOfAllSupportedFields
      });
    };
  },
  /**
   * This is used to block onInit for specific case like Issue View background refresh loading.
   */
  setExperienceDataIsLoading: function setExperienceDataIsLoading(experienceDataIsLoading) {
    return function (_ref5) {
      var setState = _ref5.setState;
      setState({
        experienceDataIsLoading: experienceDataIsLoading
      });
    };
  },
  setAppErrors: setAppErrors,
  resetAppErrors: resetAppErrors,
  addAppsErrors: addAppsErrors,
  initializeNoScreenTab: initializeNoScreenTab,
  initializeScreenTabs: initializeScreenTabs,
  updateScreenTabs: updateScreenTabs,
  updateActiveScreenTab: updateActiveScreenTab,
  detectAppliedChangesConflicts: detectAppliedChangesConflicts,
  collectScreenTabsAppliedChangesHistory: collectScreenTabsAppliedChangesHistory,
  collectFieldsAppliedChangesHistory: collectFieldsAppliedChangesHistory,
  setNotification: setNotification,
  resetNotification: resetNotification
};

// It was required to satisfiy TS with the async action

export var store = createStore({
  name: name,
  initialState: initialState,
  actions: actions
});
export var useIssueAdjustments = createHook(store);
var stableEmptyFieldFromIframe = {};
export var useAdjustedFields = createHook(store, {
  selector: function selector(state) {
    return state.appliedChanges;
  }
});
export var useAdjustedField = createHook(store, {
  selector: function selector(state, fieldId) {
    var _state$appliedChanges;
    return ((_state$appliedChanges = state.appliedChanges) === null || _state$appliedChanges === void 0 ? void 0 : _state$appliedChanges[fieldId]) || stableEmptyFieldFromIframe;
  }
});
export var useIssueAdjustmentsActions = createActionsHook(store);
export var useAdjustedScreenTabs = createHook(store, {
  selector: function selector(state) {
    return state.screenTabs;
  }
});